<template>
    <div>
        <b-row>
            <b-col cols="12">
                <div class="solution-steps">
                    <b-tabs pills content-class="mt-4" align="center">
                        <b-tab title="Calculate" @click="emitEvent('reset-shows-props', 'reset-select-product')">
                        </b-tab>
                        <b-tab title="Bank" :active="showMortgageBank" @click="emitEvent('show-mortgage-bank')">
                            <MortgageBankSelection />
                        </b-tab>
                        <b-tab title="Mortgage" :active="showMortgageSelection" @click="emitEvent('show-mortgage-selection')">
                            <MortgageSelection />
                        </b-tab>
                        <b-tab title="Summary" :active="showMortgageSummary" @click="emitEvent('show-mortgage-summary')">
                            <MortgageSummary />
                        </b-tab>
                    </b-tabs>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { Tabs, TabPane } from 'element-ui'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import MortgageBankSelection from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/MortgageSolution/MortgageBankSelection'
import MortgageSelection from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/MortgageSolution/MortgageSelection'
import MortgageSummary from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/MortgageSolution/MortgageSummary'

export default {
    props: {
        showMortgageBank: Boolean,
        showMortgageSelection: Boolean,
        showMortgageSummary: Boolean,
    },
    components: {
        MortgageBankSelection,
        MortgageSelection,
        MortgageSummary,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
    },
    methods: {
        emitEvent(...eventNames) {
            eventNames.forEach(eventName => {
                solutionEventBus.$emit(eventName)
            })
        }
    },
}
</script>